module.exports = __webpack_public_path__ + "front/img/p18_a.51b3a52b.png";